//Check if the page has main product div
if (document.querySelector('.t4s-main-product__content')) {
  //Check if the page has product container
  if (document.querySelector('.t4s-product__info-container')) {
    //Check if it has product bundler div 
    const shopifyBlocks = document.querySelectorAll('.t4s-product__info-container .shopify-block.shopify-app-block');
    if (shopifyBlocks.length > 0) {
      //Create a parent Dic
      const parentDiv = document.createElement('div')
      parentDiv.classList.add('product-bunldler');

      //Add all .shopify divs elements to the parent div 
      shopifyBlocks.forEach(blocks => {
        parentDiv.appendChild(blocks);
      });

      //Find the t4s-product-form__variants div
      const variantDiv = document.querySelector('.t4s-product-form__variants ');

      //Insert the new parent Div after .t4s-product-form__variants 
      variantDiv.parentNode.insertBefore(parentDiv, variantDiv.nextSibling);

      //Check if it has bndlr-product-conatiner
      const innerProductContainer = document.querySelector('.bndlr-inner-products-container div');
      if (innerProductContainer) {
        //Check if it has .bndlr-product
        const bndlrProduct = innerProductContainer.querySelectorAll('.bndlr-product');
        if (bndlrProduct.length > 0) {
          //Add parentDiv to each .bndlr-product
          const parentDiv1 = document.createElement('div');
          parentDiv1.classList.add('bndlr-product');

          bndlrProduct.forEach(product => {
            product.appendChild(parentDiv1.parentNode(true));
          })
        }
      }
    }
  }
}